import React from 'react'
import { Switch, Route, NotFound } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { ChineseNLIHP, SurnamePage, SurnamePicker } from '@fs/home-chinese-pages'
import { i18n } from '@fs/zion-locale'

const AboutPage = React.lazy(() => import('./pages/AboutPage/AboutPage'))
const SponsorshipPage = React.lazy(() => import('./pages/SponsorshipPage/SponsorshipPage'))
const RootsTechConnectProject = React.lazy(() => import('./pages/RootsTechConnectProject'))

function App(props) {
  const chineseSurnamePath = `(姓氏|${encodeURIComponent('姓氏')}|xìngshì|${encodeURIComponent('xìngshì')})`
  const homePath = '(home|home-react)?'
  const localePath = '([a-z]{2})?'
  const rootPath = `/${localePath}/${homePath}`
  return (
    <ErrorBoundary>
      <Switch>
        <Route path={`${rootPath}/about`} component={AboutPage} />
        <Route path={`${rootPath}/sponsorship`} component={SponsorshipPage} />
        <Route path={`${rootPath}/connect`} render={() => <RootsTechConnectProject {...props} />} />

        <Route path={`/(zh)?/${homePath}/${chineseSurnamePath}/:surname(.{1,2})`} component={SurnamePage} />
        <Route exact path={`/(zh)?/${homePath}/${chineseSurnamePath}`} component={SurnamePicker} />
        <Route exact path={rootPath} component={() => (i18n.language === 'zh' ? <ChineseNLIHP /> : <NotFound />)} />
        <Route component={NotFound} />
      </Switch>
    </ErrorBoundary>
  )
}
export default App
